const findByRoute = (config, lPath) => {
  const path = `/${lPath.shift()}`;
  const select = config.routes.find(route => route.path === path);
  if (!select) return null;
  if (lPath.length > 0) return findByRoute(select, lPath);
  return select;
};

export const getRouteConfig = state => (route) => { //eslint-disable-line
  const lPath = route.path.split('/').slice(1);
  return findByRoute(state.config, lPath);
};

export const getCurrentWave = state => state.attributes.wave || state.wave || -1;
export const getProducts = state => state.config.routes[0].products;
export const getCollections = state => state.config.collections;

export const getProductById = state => searchId =>
  getProducts(state).find(({ id, shortId }) => id === searchId || shortId === searchId);

export const getProductsByValue = state => searchValue =>
  getProducts(state).filter(({ value }) => value === searchValue);

// By default, search by the current wave value (set in config.wave)
// and returns all product that are in the current wave or previous
// meaning searching for wave 2 will return products on wave 1 and 2
// If excluded is set to true, will return the opposite, meaning the next waves
export const getProductsByWave = state => (excluded = false) => {
  const searchWave = getCurrentWave();
  if (searchWave < 0) return getProducts(state);
  return getProducts(state).filter(({ wave }) => {
    if (!excluded) {
      return wave <= searchWave;
    }
    return wave > searchWave;
  });
};

// search by collection id returns all products that are in the collection
export const getProductsByCollectionId = state => searchId =>
  getProducts(state).filter(({ collection }) => (Array.isArray(collection) ? collection.includes(searchId) : collection === searchId));

// returns the collection object by the id, and add the corresponding products
export const getCollectionById = state => (searchId) => {
  const coll = getCollections(state).find(({ id }) => id === searchId);
  if (coll) {
    coll.products = getProductsByCollectionId(state)(searchId);
  }
  return coll;
};

